import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_apexcharts = _resolveComponent("apexcharts")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_checkbox_btn = _resolveComponent("v-checkbox-btn")!
  const _component_v_data_table = _resolveComponent("v-data-table")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createBlock(_component_v_container, { height: "400px" }, {
    default: _withCtx(() => [
      _createVNode(_component_v_row, { class: "mt-1" }, {
        default: _withCtx(() => [
          _createVNode(_component_v_col, {
            cols: "12",
            md: "8"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_apexcharts, {
                height: "400px",
                series: _ctx.selectedCharts,
                options: _ctx.chartOptions
              }, null, 8, ["series", "options"])
            ]),
            _: 1
          }),
          _createVNode(_component_v_col, { md: "4" }, {
            default: _withCtx(() => [
              _createVNode(_component_v_data_table, {
                headers: _ctx.headers,
                items: _ctx.chartData,
                height: "400px",
                density: "compact",
                "items-per-page": "-1",
                "hide-default-footer": "true",
                class: "elevation-1"
              }, {
                [`item.enable`]: _withCtx(({ item }) => [
                  _createVNode(_component_v_checkbox_btn, {
                    modelValue: _ctx.selectedCharts,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedCharts) = $event)),
                    value: item.value
                  }, {
                    label: _withCtx(() => [
                      _createElementVNode("span", null, _toDisplayString(_ctx.camelCaseToWords(item.value.name)), 1)
                    ]),
                    _: 2
                  }, 1032, ["modelValue", "value"])
                ]),
                "no-data": _withCtx(() => [...(_cache[1] || (_cache[1] = [
                  _createElementVNode("span", null, "No data available", -1)
                ]))]),
                _: 2
              }, 1032, ["headers", "items"])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}